import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  width: 'fit-content',
  margin: 0,
  padding: 0,
  position: 'relative',
});

export const StyledTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 600,
  margin: 0,
  padding: 0,
  marginBottom: '0.25rem',
}));

export const StyledValueContainer = styled(Box)({
  display: 'inline-flex',
  alignItems: 'flex-end',
  gap: '0.5rem',
  width: 'fit-content',
  margin: 0,
  padding: 0,
});

export const StyledMainValueContainer = styled(Box)({
  position: 'relative',
  display: 'inline-block',
  margin: 0,
  padding: 0,
});

export const StyledMainValue = styled(Typography)({
  color: '#000000',
  fontSize: '3rem',
  fontWeight: 'bold',
  lineHeight: 1,
  margin: 0,
  padding: 0,
  display: 'inline-block',
  transition: 'all 0.3s ease-in-out',
  animation: 'countUp 0.8s ease-out',
  '@keyframes countUp': {
    from: {
      opacity: 0,
      transform: 'scale(0.8)',
    },
    to: {
      opacity: 1,
      transform: 'scale(1)',
    },
  },
});

export const StyledPercentageContainer = styled(Box)({
  display: 'inline-flex',
  alignItems: 'flex-end',
  gap: '0.25rem',
  margin: 0,
  padding: 0,
  animation: 'slideInRight 0.5s ease-out 0.2s both',
  '@keyframes slideInRight': {
    from: {
      opacity: 0,
      transform: 'translateX(-10px)',
    },
    to: {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
});

export const StyledArrow = styled('span')<{ color: string }>(({ color }) => ({
  display: 'inline-flex',
  alignItems: 'flex-end',
  color,
  fontSize: 'inherit',
  lineHeight: 1,
  margin: 0,
  padding: 0,
  transition: 'transform 0.3s ease-in-out',
  animation: 'pulse 2s ease-in-out infinite',
  '@keyframes pulse': {
    '0%, 100%': {
      transform: 'scale(1)',
    },
    '50%': {
      transform: 'scale(1.1)',
    },
  },
}));

export const StyledPercentage = styled(Typography)<{ color: string }>(({ color }) => ({
  color,
  fontSize: 'inherit',
  fontWeight: 'bold',
  lineHeight: 1,
  margin: 0,
  padding: 0,
  display: 'inline-block',
}));

export const StyledUnitBadge = styled(Box)({
  position: 'absolute',
  bottom: '-16px',
  left: 0,
  backgroundColor: '#2196F3',
  color: '#FFFFFF',
  fontSize: '0.5rem',
  fontWeight: 600,
  padding: '3px',
  borderRadius: '3px',
  lineHeight: 1,
  letterSpacing: '0.3px',
  whiteSpace: 'nowrap',
  boxShadow: '0 2px 4px rgba(33, 150, 243, 0.3)',
  transition: 'all 0.3s ease-in-out',
  animation: 'fadeIn 0.6s ease-out 0.4s both',
  '@keyframes fadeIn': {
    from: {
      opacity: 0,
      transform: 'translateY(-5px)',
    },
    to: {
      opacity: 1,
      transform: 'translateY(0)',
    },
  },
});
